<template>
    <div class="recharge-delivery-table">
        <el-table v-loading="isLoading"
            style="width: 100%"
            :data="rechargeBonusActivitys">
            <el-table-column
                label="活动时间"
                min-width="120">
                <template v-slot="{ row }">
                    <p>长期有效</p>
                </template>
            </el-table-column>
            <el-table-column
                label="充值送"
                min-width="155">
                <template v-slot="{ row }">
                    <div v-if="row.levels.length > 0"
                        class="pt-12 pb-12">
                        <p v-for="(item, index) in row.levels"
                        :key="item.threshold"
                        :style="{
                            lineHeight: '20px',
                            marginTop: index === 0 ? 0 : '4px'
                        }">满{{ parseFloatFn(item.threshold) }}元送{{ parseFloatFn(item.bonus_amount) }}元</p>
                    </div>
                    <p v-else>-</p>
                </template>
            </el-table-column>
            <el-table-column
                label="已参与"
                min-width="80"
                align="right">
                <template v-slot="{ row }">
                    <p>{{ row.participated_person }}人</p>
                </template>
            </el-table-column>
            <el-table-column/>
            <el-table-column
                label="引导充值"
                min-width="120"
                align="right">
                <template v-slot:header="{ row }">
                    <span>引导充值</span>
                    <question-icon :content="'不包含赠送金额'"
                        :popperWidth="'105px'"/>
                </template>
                <template v-slot="{ row }">
                    <p class="pr-24">{{ parseFloatFn(row.guided_recharge) }}元</p>
                </template>
            </el-table-column>
            <el-table-column/>
            <el-table-column
                label="活动状态"
                min-width="80"
                align="right">
                <template v-slot="{ row }">
                    <p>{{ statusType[row.status] }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="140">
                <template v-slot="{ row }">
                    <button class="text-btn pl-0 pr-12" @click="updateRecharge(row.levels, row.activity_id, row.cashier_custom_recharge)">编辑</button>
                    <!-- <my-switch v-model="row.isChecked"
                        @change="elSwitchChange"/> -->
                </template>
            </el-table-column>
            <!-- slot empty -->
            <template slot="empty">
                <template v-if="!isLoading">
                    <span class="color-999">暂无充值送活动，</span><button class="text-btn pl-0 pr-0" @click="createRecharge">去设置</button>
                </template>
                <span v-else></span>
            </template>
        </el-table>
        <!-- components -->
        <recharge-delivery-slider :mode="mode"
            :activityId="activityId"
            :oldLevels="oldLevels"
            :customRecharge="customRecharge"
            :visible.sync="isShowSlider"
            :confirmCallback="getRechargeBonusActivity"/>
    </div>
</template>

<script lang='ts'>
import { createComponent, ref, onBeforeMount } from '@vue/composition-api'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import MySwitch from '../../components/my_switch.vue'
import RechargeDeliverySlider from './recharge_delivery_slider.vue'
import { openMessage } from '../../../../utils/system'
import $fetch from '../../../../api'
import clone from 'lodash/cloneDeep'
import { fixNum } from '../../../../utils'

interface OldLevel {
    threshold: number
    bonus_amount: number
}

interface RechargeBonusActivity {
    guided_recharge: string
    participated_person: number
    levels: OldLevels,
    activity_id: number,
    status: number
}

type RechargeBonusActivitys = RechargeBonusActivity[]

export type OldLevels = OldLevel[]

export default createComponent({
    setup(props, ctx) {
        const isLoading = ref(false)
        const isShowSlider = ref(false)
        const mode = ref<'update' | 'create'>('create')
        const activityId = ref<number>(0)
        const customRecharge = ref<number>(0)
        const oldLevels = ref<OldLevels>([])
        const rechargeBonusActivitys = ref<RechargeBonusActivitys>([])

        const statusType = {
            '0': '进行中',
            '-1': '已停用'
        }

        onBeforeMount(() => {
            getRechargeBonusActivity()
        })

        function createRecharge() {
            mode.value = 'create'
            isShowSlider.value = true
        }

        function updateRecharge(ols: OldLevels, aId: number, cR: number) {
            oldLevels.value = ols.map(ol => {
                const obj: OldLevel = {
                    threshold: 0,
                    bonus_amount: 0
                }
                Object.keys(ol).forEach(k => obj[k] = parseFloatFn(ol[k]))

                return obj
            })
            activityId.value = aId
            customRecharge.value = cR
            mode.value = 'update'
            isShowSlider.value = true
        }

        function parseFloatFn(n: number | string) {
            return window.parseFloat(n.toString())
        }

        function addChecked(rs: RechargeBonusActivitys) {
            return rs.map(r => {
                const obj = {
                    ...r,
                    isChecked: r.status === 0 ? true : false
                }

                return obj
            })
        }

        async function elSwitchChange(newVal) {
            await changeChargeBonusStatus(newVal ? 'enable' : 'disable')
            await getRechargeBonusActivity()
        }

        async function changeChargeBonusStatus(type: 'enable' | 'disable') {
            try {
                switch (type) {
                    case 'enable':
                        await $fetch.post({
                            url: '/activity/enablerechargebonus',
                            params: {
                                activity_id: activityId.value
                            }
                        })
                        openMessage('success', '启用成功')
                        break
                    case 'disable':
                        await $fetch.post({
                            url: '/activity/disablerechargebonus',
                            params: {
                                activity_id: activityId.value
                            }
                        })
                        openMessage('success', '停用成功')
                        break
                    default:
                        break
                }
            } catch (e) {
                openMessage('error', e.message || '修改状态失败')
            }
        }

        async function getRechargeBonusActivity() {
            try {
                isLoading.value = true
                const result = await $fetch.post({
                    url: '/activity/getrechargebonusactivity'
                })
                console.log('充值送活动详情', clone(result))
                if (Object.keys(result).length !== 0) {
                    activityId.value = result.activity_id
                    rechargeBonusActivitys.value = addChecked([result])
                }
            } catch (e) {
                openMessage('error', e.message || '获取会员余额充值送活动详情失败')
            } finally {
                isLoading.value = false
            }
        }

        return {
            // data
            isLoading,
            isShowSlider,
            mode,
            oldLevels,
            rechargeBonusActivitys,
            statusType,
            activityId,
            customRecharge,
            // methods
            createRecharge,
            updateRecharge,
            getRechargeBonusActivity,
            parseFloatFn,
            elSwitchChange
        }
    },
    components: {
        QuestionIcon,
        MySwitch,
        RechargeDeliverySlider
    }
})
</script>

<style lang="scss" scoped>

</style>
